import InstitutionsSelect from './institutions-select';

export default InstitutionsSelect;
